import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { UserState } from '../models'

const defaultState: UserState = {
    CompanyType: '',
    CompanyStartYear: '',
    Email: '',
    FirstName: '',
    LastName: '',
    Role: '',
    UserId: '',
    UiLanguage: '',
    authenticated: false,
}

interface UserStore {
    user: UserState
    updateAuthenticatedUser: (user: UserState) => void
    userSignOut: () => void
    updateLanguage: (language: string) => void
}

export const useUserStore = create<UserStore>()(
    persist(
        set => ({
            user: { ...defaultState },
            updateAuthenticatedUser: (user: UserState) => set({ user: { ...user } }),
            userSignOut: () => set({ user: { ...defaultState } }),
            updateLanguage: (language: string) => set(state => ({ user: { ...state.user, UiLanguage: language } })),
        }),
        {
            name: 'user-storage',
        }
    )
)
